import { Users } from "lucide-react";
import type { ModuleSpec } from "../types";

/**
 * "Team" — the org's team members.
 *
 * Previously labeled "Users" and bucketed under the Account/Settings group.
 * Renamed to "Team" via i18n (id stays `users` so routes/permissions/code
 * references stay stable) and moved to the new `team` group so it sits
 * alongside Contact Center and Team Insights.
 */
export const usersSpec: ModuleSpec = {
  id: "users",
  icon: Users,
  i18n: {
    namespace: "modules",
    titleKey: "users.title",
    descriptionKey: "users.description",
  },
  nav: {
    path: "/users",
    group: "team",
    order: 10,
  },
  permission: {
    action: "read",
    subject: "user",
  },
  meta: {
    status: "active",
    description: "Manage team members, roles, and permissions",
  },
};
